import { ReactNode } from "react";
import { AioIconButton } from "../additional/aioIconButton";
import { AitRowGroupData } from "./functions/AitRowGroupData";
import { getBaseId } from "./functions/getBaseId";
import { AitLocationBodyRowGroup, REMOVE_ROW_GROUP } from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitRemoveRowGroupButtonProps {
  location: AitLocationBodyRowGroup;
}

/**
 * Button to remove a row group when allowed.
 *
 * @template T - Row group payload type
 * @param props - Component props
 * @param props.location - The row group location
 */
export const AitRemoveRowGroupButton = <T,>({
  location,
}: AitRemoveRowGroupButtonProps): ReactNode => {
  const { state, dispatch } = useTableContext<T>();
  const thisRowGroup: AitRowGroupData<T> | undefined = trGetPositionFromLocation(
    state,
    location,
    true,
  ).data;
  const id = getBaseId(location, state?.id);

  return !state ||
    !thisRowGroup ||
    !state.editable ||
    !state.processedTableData ||
    state.processedTableData.bodyData!.length < 2 ? null : (
    <AioIconButton
      id={`${id}-remove-rowgroup`}
      tipText={"Remove row group"}
      iconName={"aioxMinus"}
      onClick={() =>
        dispatch({
          operation: REMOVE_ROW_GROUP,
          location,
          newLength: state.originalTableData.bodyData.length - 1,
        })
      }
    />
  );
};

AitRemoveRowGroupButton.displayName = "AitRemoveRowGroupButton";
